// React
import React from 'react';
import PropTypes from 'prop-types';

// VDS
import Divider from '@visa/vds-react/divider-styled';
import { styles } from './component.styles';

const CybsDivider = ({ ariaHidden, dataTest, title, type, ...props }) => (
  <Divider
    aria-hidden={ariaHidden ? 'true' : undefined}
    data-test={`${dataTest}-cybsDivider`}
    title={title}
    type={type}
    customCSS={theme => styles(theme).divider}
    {...props}
  />
);

CybsDivider.propTypes = {
  /**
   * Determines if screen reader reads the title.
   */
  ariaHidden: PropTypes.bool,
  /**
   * Title for the divider. Only used when ariaHidden is false.
   */
  title: PropTypes.string,
  /**
   * Data Test
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Type of divider. Can be "standard" or "section"
   */
  type: PropTypes.oneOf(['standard', 'section'])
};

CybsDivider.defaultProps = {
  ariaHidden: undefined,
  title: 'Section',
  type: 'standard'
};

CybsDivider.displayName = 'CybsDivider';

export default CybsDivider;
